import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

import { CollapsableModel } from "@/../../EshJSLib/models/CollapsableModel";
import { patientStore } from "@/store/patient";
import actionButton from "@/components/actionButton.vue";
import { storeToRefs } from "pinia";

export default /*#__PURE__*/_defineComponent({
  __name: 'CollapsibleRowActions',
  props: {
  row: Object,
  data: Object,
},
  emits: ["action"],
  setup(__props, { emit }) {

const props = __props;

const store = patientStore();



function rowAction(type: string) {
  emit("action", type);
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data?.actions, (item, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: index,
      class: "grid-container"
    }, [
      _createVNode(actionButton, {
        style: {"margin-top":"1%","cursor":"pointer"},
        iconname: item,
        colorbackground: "#1A576E",
        onCallAction: rowAction,
        color: "red"
      }, null, 8, ["iconname"])
    ]))
  }), 128))
}
}

})